import { X, FileCode2, FileJson, FileText, FileType, Image, Database, Settings2, Terminal, Hash, Braces } from 'lucide-react'

const EXT_ICON_MAP = {
  js:     { Icon: Braces,    className: 'file-icon-js' },
  jsx:    { Icon: Braces,    className: 'file-icon-jsx' },
  mjs:    { Icon: Braces,    className: 'file-icon-js' },
  ts:     { Icon: Braces,    className: 'file-icon-ts' },
  tsx:    { Icon: Braces,    className: 'file-icon-tsx' },
  css:    { Icon: Hash,      className: 'file-icon-css' },
  scss:   { Icon: Hash,      className: 'file-icon-scss' },
  html:   { Icon: FileCode2, className: 'file-icon-html' },
  htm:    { Icon: FileCode2, className: 'file-icon-html' },
  json:   { Icon: FileJson,  className: 'file-icon-json' },
  md:     { Icon: FileText,  className: 'file-icon-md' },
  mdx:    { Icon: FileText,  className: 'file-icon-md' },
  py:     { Icon: FileCode2, className: 'file-icon-py' },
  rb:     { Icon: FileCode2, className: 'file-icon-rb' },
  go:     { Icon: FileCode2, className: 'file-icon-go' },
  rs:     { Icon: FileCode2, className: 'file-icon-rs' },
  java:   { Icon: FileCode2, className: 'file-icon-java' },
  kt:     { Icon: FileCode2, className: 'file-icon-kt' },
  cpp:    { Icon: FileCode2, className: 'file-icon-cpp' },
  c:      { Icon: FileCode2, className: 'file-icon-c' },
  h:      { Icon: FileCode2, className: 'file-icon-c' },
  swift:  { Icon: FileCode2, className: 'file-icon-swift' },
  dart:   { Icon: FileCode2, className: 'file-icon-dart' },
  php:    { Icon: FileCode2, className: 'file-icon-php' },
  sql:    { Icon: Database,  className: 'file-icon-sql' },
  yml:    { Icon: Settings2, className: 'file-icon-yml' },
  yaml:   { Icon: Settings2, className: 'file-icon-yaml' },
  xml:    { Icon: FileCode2, className: 'file-icon-xml' },
  svg:    { Icon: Image,     className: 'file-icon-svg' },
  sh:     { Icon: Terminal,  className: 'file-icon-sh' },
  bash:   { Icon: Terminal,  className: 'file-icon-sh' },
  env:    { Icon: Settings2, className: 'file-icon-env' },
  png:    { Icon: Image,     className: 'file-icon-default' },
  jpg:    { Icon: Image,     className: 'file-icon-default' },
  gif:    { Icon: Image,     className: 'file-icon-default' },
  toml:   { Icon: Settings2, className: 'file-icon-default' },
  ini:    { Icon: Settings2, className: 'file-icon-default' },
}

function getFileIcon(fileName) {
  if (!fileName) return { Icon: FileType, className: 'file-icon-default' }
  const lower = fileName.toLowerCase()
  if (lower === 'dockerfile') return { Icon: FileCode2, className: 'file-icon-docker' }
  if (lower === '.gitignore') return { Icon: FileCode2, className: 'file-icon-git' }
  const ext = lower.includes('.') ? lower.split('.').pop() : ''
  return EXT_ICON_MAP[ext] || { Icon: FileType, className: 'file-icon-default' }
}

export function FileIcon({ fileName, size = 14 }) {
  const { Icon, className } = getFileIcon(fileName)
  return <Icon size={size} className={className} strokeWidth={1.8} />
}

export function EditorTabs({ files, activeFilePath, onSelect, onClose }) {
  if (!files.length) {
    return <div className="empty-tabs">No files open</div>
  }

  return (
    <div className="editor-tabs">
      {files.map(file => {
        const isActive = file.path === activeFilePath

        return (
          <button
            key={file.path}
            className={isActive ? 'editor-tab active' : 'editor-tab'}
            onClick={() => onSelect(file.path)}
          >
            <span className="editor-tab-icon">
              <FileIcon fileName={file.name} size={14} />
            </span>
            <span className="editor-tab-name">
              {file.name}
              {file.dirty && <span className="editor-tab-modified" title="Unsaved changes" />}
            </span>
            <span
              className="editor-tab-close"
              title="Close"
              onClick={event => {
                event.stopPropagation()
                onClose(file.path)
              }}
            >
              <X size={12} />
            </span>
          </button>
        )
      })}
    </div>
  )
}
